// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// This file written by Saravana Ravichandran to manage environments
export const _ENVRONMENTWRAPPER = {
  BASE_API_URL: "https://iswaryacrmapi.quad1test.com",
  //BASE_API_URL: "https://qcrmapi.quad1test.com",
 // BASE_API_URL: "https://localhost:44339",
};
export const environment = {
  production: false,
  forceHttps: false,
  socketApiUrl: "https://socketio-chat-h9jt.herokuapp.com/",
  socketIoUrl: "https://socketio-chat-h9jt.herokuapp.com/",
  notificationEndpoint: _ENVRONMENTWRAPPER.BASE_API_URL,
  apiUrl: _ENVRONMENTWRAPPER.BASE_API_URL + "/api/v1/",
  apiUrlV2: _ENVRONMENTWRAPPER.BASE_API_URL + "/api/v2/",
  dialerIframeUrl: "https://115.110.182.71/touchpoint",
  dialerParentURL: "https://mycrm-staging.apollocare.in",
  askapolloAPiURL: "https://uatapiservices.askapollo.com/",
  askapolloApiKey: "AHLLCRMUAT-4645-4891-9C69-FA031CC0A616",
  IsThirdPartyIntegration: "2",
};

/* Any Quries in this application Please Contact Rajasekhar Ragiri , Email Id: rajasekhar.ragiri@quadone.com
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
